import React, { Component } from 'react';
import { Thumbnail, Col, Row, Button } from 'react-bootstrap'
import { connect } from 'react-redux'
import _ from 'lodash'
import Slider from 'react-slick'
import MetaTags from 'react-meta-tags'
import { fetchSearchInput, fetchProduct, updateCartProducts, trigOverlay, fetchProductsForRandom } from '../actions'
import NavHeader from './navheader'
import ProductItem from './product_item'
import ProductDescriptionDetail from './product_description_detail'
import Footer from './footer'
import Lightbox from 'react-images';
import ReactPlaceholder from 'react-placeholder';
import { isInArray } from '../utils';
var FontAwesome = require('react-fontawesome')
function PrevArrow(props) {
    const { className, style, onClick } = props
    return (
        <image className={className} onClick={onClick} style={{ width: 35, height: 35, left: '-35px !important' }} src='../../static/images/carouselArrow/backward.png' />
    )
}
function NextArrow(props) {
    const { className, style, onClick } = props
    return (
        <image className={className} onClick={onClick} style={{ width: 35, height: 35, right: '-35px !important' }} src='../../static/images/carouselArrow/forward.png' />
    )
}
var randomSize = 25
class Product extends Component {
    constructor() {
        super();
        this.closeLightbox = this.closeLightbox.bind(this);
        this.openLightbox = this.openLightbox.bind(this);
    }
    state = {
        amount: 1,
        loading: true,
        description: '',
        isKg: false
    }
    componentWillMount() {
        this.props.fetchProductsForRandom()
        this.props.fetchSearchInput('')
        this.props.fetchProduct(this.props.id).then(Response => {
            this.setState({ loading: false })
        })
        window.scrollTo(0, 0)
    }
    componentWillReceiveProps(nextProps) {
        if (nextProps.product != "") {
            this.setState({ loading: false })
            if (this.getProductUnit(nextProps.product) == 'กิโลกรัม') {
                this.setState({ amount: 0.3, isKg: true })
            }
        }
    }
    componentDidMount() {
        window.scrollTo(0, 0)
    }
    openLightbox(event, obj) {
        this.setState({
            currentImage: obj.index,
            lightboxIsOpen: true,
        });
    }
    closeLightbox() {
        this.setState({
            currentImage: 0,
            lightboxIsOpen: false,
        });
    }
    getRandomProducts(products) {
        var randomIndexs = [], randomProducts = {}, i = 0
        randomIndexs = this.pushRandomIndex(randomIndexs, Object.keys(products).length, 1)
        for (var key in products) {
            if (randomIndexs.includes(i)) {
                randomProducts[key] = {}
                randomProducts[key] = products[key]
            }
            i++
        }
        return randomProducts
    }
    pushRandomIndex(randomIndexs, length, count) {
        if (count > randomSize) {
            return randomIndexs
        }
        var randomIndex = Math.floor(Math.random() * length)
        if (!(randomIndexs.includes(randomIndex))) {
            randomIndexs.push(randomIndex)
            return this.pushRandomIndex(randomIndexs, length, ++count)
        } else {
            return this.pushRandomIndex(randomIndexs, length, count)
        }
    }
    renderFeatures() {
        let id = 1
        return _.map(this.props.product, product => {
            return _.map(product.product_features, feature => {
                return (
                    <p key={id++} style={{ fontWeight: 700 }}><FontAwesome
                        className='super-crazy-colors'
                        name='check-circle'
                        size='2x'
                        style={{ color: 'green', margin: 3 }}
                    />
                        {feature}</p >
                )
            })
        })
    }
    getProductId(obj) {
        let id
        for (var key in obj) {
            id = obj[key].id
        }
        return id
    }
    getPrice(obj) {
        let price
        for (var key in obj) {
            price = obj[key].price
        }
        return price
    }
    getName(obj) {
        let name
        for (var key in obj) {
            name = obj[key].name_th
        }
        return name
    }
    getImage(obj) {
        let img
        for (var key in obj) {
            img = obj[key].img_url == undefined ? obj[key].img_url_ss : obj[key].img_url
        }
        return img
    }
    getOGImage(obj) {
        let img
        for (var key in obj) {
            img = obj[key].img_url_thumbnail
        }
        return img
    }
    getDiscount(obj) {
        let discount
        for (var key in obj) {
            discount = obj[key].discount
        }
        return discount
    }
    getDescription(obj) {
        let desc
        for (var key in obj) {
            desc = obj[key].description
        }
        if (desc) {
            desc = desc.replace(/\\n/g, "\n")
        }
        return desc
    }
    getUnit(obj) {
        let unit
        for (var key in obj) {
            unit = obj[key].unit
        }
        return unit
    }
    getOutOfStock(obj) {
        let oos
        for (var key in obj) {
            oos = obj[key].is_out_of_stock
        }
        return oos
    }
    getReserveFactor(obj) {
        let reserve_factor
        for (var key in obj) {
            reserve_factor = obj[key].reserve_factor
        }
        return reserve_factor
    }
    getProductUnit(obj) {
        let product_unit
        for (var key in obj) {
            product_unit = obj[key].unit
        }
        return product_unit
    }
    onProductDescriptionChange(value) {
        this.setState({ description: value })
    }
    // let products = JSON.parse(localStorage.getItem('cart_products'))
    // products[product_id]['product_description'] = value
    //     this.props.updateCartProducts(products)
    onAddCart() {
        let bool = true
        if (this.props.product) {
            this.getProductId(this.props.product) ? '' : bool = false
            this.getName(this.props.product) ? '' : bool = false
            !isNaN(Number(this.getPrice(this.props.product).toFixed(2))) ? '' : bool = false
            // !isNaN(Number(this.getReserveFactor(this.props.product))) ? '' : bool = false
            this.getProductUnit(this.props.product) ? '' : bool = false
            this.state.amount ? '' : bool = false
            this.getImage(this.props.product) ? '' : bool = false
        } else {
            bool = false
        }
        if (bool) {
            if (this.state.description) {
                let products = JSON.parse(localStorage.getItem('cart_products'))
                let product_id = this.getProductId(this.props.product)
                let product_name = this.getName(this.props.product)
                let product_amount = Number(this.state.amount)
                let product_price_unit = Number(this.getPrice(this.props.product).toFixed(2))
                let product_image_url = this.getImage(this.props.product)
                let product_reserve_factor = Number(this.getReserveFactor(this.props.product))
                let product_unit = this.getProductUnit(this.props.product)
                if (products != null) {
                    if (products[product_id]) {
                        products[product_id] = {
                            product_id: product_id,
                            product_name: product_name,
                            product_price_unit: Number(products[product_id]['product_price_unit']),
                            product_amount: Number((Number(products[product_id]['product_amount']) + product_amount).toFixed(12)),
                            product_image_url: product_image_url,
                            product_reserve_factor: product_reserve_factor,
                            product_unit: product_unit,
                            product_description: this.state.description
                        }
                    } else {
                        products[product_id] = {
                            product_id: product_id,
                            product_name: product_name,
                            product_price_unit: product_price_unit,
                            product_amount: product_amount,
                            product_image_url: product_image_url,
                            product_reserve_factor: product_reserve_factor,
                            product_unit: product_unit,
                            product_description: this.state.description
                        }
                    }
                } else {
                    products = {}
                    products[product_id] = {
                        product_id: product_id,
                        product_name: product_name,
                        product_price_unit: product_price_unit,
                        product_amount: product_amount,
                        product_image_url: product_image_url,
                        product_reserve_factor: product_reserve_factor,
                        product_unit: product_unit,
                        product_description: this.state.description
                    }
                }
                localStorage.setItem('cart_products', JSON.stringify(products))
                this.setState({ description: '' })
                this.props.updateCartProducts(products)
                this.props.trigOverlay({ product_name: product_name, product_amount: product_amount, product_unit: product_unit })
            } else {
                let products = JSON.parse(localStorage.getItem('cart_products'))
                let product_id = this.getProductId(this.props.product)
                let product_name = this.getName(this.props.product)
                let product_amount = Number(this.state.amount)
                let product_price_unit = Number(this.getPrice(this.props.product).toFixed(2))
                let product_image_url = this.getImage(this.props.product)
                let product_reserve_factor = Number(this.getReserveFactor(this.props.product))
                let product_unit = this.getProductUnit(this.props.product)
                if (products != null) {
                    if (products[product_id]) {
                        products[product_id] = {
                            product_id: product_id,
                            product_name: product_name,
                            product_price_unit: Number(products[product_id]['product_price_unit']),
                            product_amount: Number((Number(products[product_id]['product_amount']) + product_amount).toFixed(12)),
                            product_image_url: product_image_url,
                            product_reserve_factor: product_reserve_factor,
                            product_unit: product_unit,
                            product_description: products[product_id]['product_description'],
                        }
                    } else {
                        products[product_id] = {
                            product_id: product_id,
                            product_name: product_name,
                            product_price_unit: product_price_unit,
                            product_amount: product_amount,
                            product_image_url: product_image_url,
                            product_reserve_factor: product_reserve_factor,
                            product_unit: product_unit
                        }
                    }
                } else {
                    products = {}
                    products[product_id] = {
                        product_id: product_id,
                        product_name: product_name,
                        product_price_unit: product_price_unit,
                        product_amount: product_amount,
                        product_image_url: product_image_url,
                        product_reserve_factor: product_reserve_factor,
                        product_unit: product_unit
                    }
                }
                localStorage.setItem('cart_products', JSON.stringify(products))
                this.setState({ description: '' })
                this.props.updateCartProducts(products)
                this.props.trigOverlay({ product_name: product_name, product_amount: product_amount, product_unit: product_unit })
            }
        } else {
            console.log('เกิดข้อผิดพลาดในการเพิ่มสินค้า')
        }
    }
    onAmountChange(value) {
        let decimal = (value % 1).toFixed(12)
        decimal = String(Number(decimal))
        let decimal_count = 0
        for (var i = 2; i < decimal.length; i++) {
            decimal_count += 1
        }
        if ((value >= 0 || value == '') && decimal_count < 2) {
            this.setState({ amount: value })
        }
    }
    onIncreaseAmount() {
        let step = this.state.isKg ? 0.1 : 1
        this.setState({ amount: Number((this.state.amount + step).toFixed(1)) })
    }
    onDecreaseAmount() {
        let step = this.state.isKg ? 0.1 : 1
        if (Number(this.state.amount) - step > 0) {
            this.setState({ amount: Number((this.state.amount - step).toFixed(1)) })
        }
    }
    renderCarouselEvent(products, slidesToShow) {
        var setting = {
            responsive: [
                {
                    breakpoint: 767, settings: {
                        dots: false,
                        infinite: true,
                        speed: 500,
                        slidesToShow: 2,
                        slidesToScroll: 1,
                        autoplay: true,
                        swipeToSlide: true,
                        prevArrow: <PrevArrow />,
                        nextArrow: <NextArrow />,
                    }
                },
                {
                    breakpoint: 991, settings: {
                        dots: false,
                        infinite: true,
                        speed: 500,
                        slidesToShow: slidesToShow,
                        slidesToScroll: 1,
                        autoplay: true,
                        swipeToSlide: true,
                        prevArrow: <PrevArrow />,
                        nextArrow: <NextArrow />,
                    }
                },
                {
                    breakpoint: 2599, settings: {
                        dots: false,
                        infinite: true,
                        speed: 500,
                        slidesToShow: slidesToShow,
                        slidesToScroll: 1,
                        autoplay: true,
                        swipeToSlide: true,
                        prevArrow: <PrevArrow />,
                        nextArrow: <NextArrow />,
                    }
                }
            ]
        }
        let id = 0
        let listSiteShow = []
        _.map(products, product => {
            if (product.visible) {
                listSiteShow.push(<div key={id++} style={{ padding: 7 }}><ProductItem isCarousel={true} product={product} history={this.props.history} /></div>)
            }
        })
        if (!_.isEmpty(products)) {
            return (
                <div style={{ paddingLeft: 50, paddingRight: 50 }}>
                    <Slider {...setting}>
                        {listSiteShow}
                    </Slider>
                </div>
            )
        } else {
            return <div></div>
        }
    }
    render() {
        var is_out_of_stock = this.getOutOfStock(this.props.product)
        // this.state.loading == false && !_.isEmpty(this.props.productsForRandom) ? console.log('metatag') : ''
        const sth = this.getDescription(this.props.product)
        return (
            this.props.product != 'not_found' ?
                <div className='container'>
                    {this.state.loading == false && !_.isEmpty(this.props.productsForRandom)
                        ? <MetaTags>
                            <title>{'สินค้าส่งสด - ' + this.getName(this.props.product)}</title>
                            <meta property="og:title" content={"สินค้าส่งสด - " + this.getName(this.props.product)} />
                            <meta property="og:url" content={window.location.href} />
                            <meta property="og:image" content={this.getOGImage(this.props.product)} />
                            <meta property="og:description" content={this.getDescription(this.props.product)} />
                            <meta property="og:type" content='website' />
                            <meta property="fb:pages" content="129193147647837" />
                        </MetaTags> : ''}
                    <div className="container main-bg">
                        <div className="row">
                            <Col style={{}}>
                                {(this.state.loading == true
                                    ? <div style={{ marginLeft: 15, marginTop: 30, marginBottom: 10 }}></div>
                                    : <div><h2 style={{ marginLeft: 15, marginTop: 30, marginBottom: 10 }}>{this.getName(this.props.product)}</h2></div>
                                )}
                                <Row>
                                    <Col xs={12} sm={6} md={6}>
                                        <ReactPlaceholder type='rect'
                                            style={{ width: 500, height: 370 }}
                                            className='my-rect'
                                            ready={!this.state.loading}>
                                            <div><Lightbox
                                                images={[{ src: `${this.getImage(this.props.product)}` }]}
                                                isOpen={this.state.lightboxIsOpen}
                                                onClickPrev={this.gotoPrevious}
                                                onClickNext={this.gotoNext}
                                                onClose={this.closeLightbox}
                                                backdropClosesModal={true}
                                                width={1024}
                                            />
                                                <img className="img"
                                                    onClick={this.openLightbox}
                                                    style={{ width: '100% !important', cursor: 'pointer' }}
                                                    src={this.getImage(this.props.product)}></img></div>
                                        </ReactPlaceholder>
                                    </Col>
                                    <Col xs={12} sm={6} md={6} style={{ paddingTop: 10, paddingBottom: 10 }}>
                                        <ReactPlaceholder type='media' rows={4} ready={!this.state.loading}>
                                            <div style={{ backgroundColor: '#fafafa' }}>{this.renderFeatures()}</div>
                                        </ReactPlaceholder>
                                    </Col>
                                    <Col xs={12} sm={6} md={6} style={{ paddingTop: 10, paddingBottom: 10 }}>
                                        <ReactPlaceholder type='media' rows={4} ready={!this.state.loading}>
                                            {/* <div><p style={{ whiteSpace: 'pre-line' }}>{this.getDescription(this.props.product)}</p></div> */}
                                            <div><p style={{ whiteSpace: 'pre-line' }}>{this.getDescription(this.props.product)}</p></div>
                                        </ReactPlaceholder>
                                        {this.getOutOfStock(this.props.product) ? <h3 style={{ margin: 3, textAlign: 'center', color: '#ff0000' }}>สินค้าหมดชั่วคราว</h3> : <h3 style={{ margin: 3, textAlign: 'center' }}>{isNaN(this.getPrice(this.props.product)) ? "" : this.getPrice(this.props.product) + " บาท / " + this.getUnit(this.props.product)}</h3>}
                                        <br />
                                        <Row>
                                            <Col xs={12} md={6} style={{ marginBottom: 5 }}>
                                                <div className="input-group">
                                                    <span className="input-group-btn">
                                                        <Button type="button" style={{
                                                            marginBottom: 4,
                                                            border: 'none !important',
                                                            color: '#ffffff !important',
                                                            background: '#f57224 !important',
                                                            background: '-webkit-linear-gradient(263deg, #f5ac24, #f57224) !important',
                                                            background: '-o-linear-gradient(263deg, #f5ac24, #f57224) !important',
                                                            background: '-moz-linear-gradient(263deg, #f5ac24, #f57224) !important',
                                                            background: ' linear-gradient(263deg, #f5ac24, #f57224) !important',
                                                            height: 34
                                                        }} className="btn" disabled={is_out_of_stock ? true : false}
                                                            onClick={(e) => this.onDecreaseAmount(e)}>-</Button>
                                                    </span>
                                                    <input disabled={is_out_of_stock ? true : false} className="form-control" value={this.state.amount} onChange={e => this.onAmountChange(e.target.value)}
                                                        onBlur={() => {
                                                            this.state.amount == '' || this.state.amount == 0 ?
                                                                this.setState({ amount: 1 })
                                                                : ''
                                                        }}
                                                        placeholder={'จำนวน'} type='number' />
                                                    <span className="input-group-btn">
                                                        <Button type="button" style={{
                                                            marginBottom: 4,
                                                            border: 'none !important',
                                                            color: '#ffffff !important',
                                                            background: '#f57224 !important',
                                                            background: '-webkit-linear-gradient(263deg, #f5ac24, #f57224) !important',
                                                            background: '-o-linear-gradient(263deg, #f5ac24, #f57224) !important',
                                                            background: '-moz-linear-gradient(263deg, #f5ac24, #f57224) !important',
                                                            background: ' linear-gradient(263deg, #f5ac24, #f57224) !important',
                                                            height: 34
                                                        }} className="btn" disabled={is_out_of_stock ? true : false}
                                                            onClick={(e) => this.onIncreaseAmount(e)}>+</Button>
                                                    </span>
                                                </div>
                                            </Col>
                                            <Col xs={12} md={6}>
                                                <Button className='btn-add-to-cart' disabled={is_out_of_stock || this.state.amount == '' || this.state.amount == 0 ? true : false} style={{ width: 100 + '%', height: 35 }} onClick={() => this.onAddCart()}>หยิบใส่ตะกร้า</Button>
                                            </Col>
                                            <div style={{ padding: 15 }}>
                                                <textarea style={{ width: '100%' }} placeholder='กรอกความต้องการเพิ่มเติม เช่น ขอดเกล็ดปลา'
                                                    onChange={e => this.onProductDescriptionChange(e.target.value)}
                                                    value={this.state.description} rows='3' />
                                            </div>
                                        </Row>
                                    </Col>
                                </Row>
                            </Col>
                        </div>
                        <hr />
                        {!_.isEmpty(this.props.productsForRandom) ?
                            <div>
                                <h3 style={{ paddingLeft: 20 }}>สินค้าอื่นๆที่คุณอาจสนใจ</h3>
                                {this.renderCarouselEvent(this.getRandomProducts(this.props.productsForRandom.products), 4)}
                            </div> : ''
                        }
                    </div>
                </div> :
                <div className='container'><h2>404 Product Not Found</h2></div>
        )
    }
}
function mapStateToProps(state) {
    return {
        product: state.product,
        productsForRandom: state.productsForRandomReducer,
    }
}
export default connect(mapStateToProps, { fetchSearchInput, fetchProduct, updateCartProducts, trigOverlay, fetchProductsForRandom })(Product)


// WEBPACK FOOTER //
// ./src/components/product.js